import React from 'react';
import Image from 'next/image';
import { classNames } from '@repo/ui/src/utils/classNames';

const SmokeImages = ({ smokeImgUrl, isAnimating }: { smokeImgUrl: string; isAnimating: any }) => {
  return (
    <div
      className={classNames(
        'smoke-wrapper tw-absolute tw-bottom-0 tw-left-0 tw-w-full tw-z-0 tw-pt-[32.25%] motion-reduce:tw-opacity-80 motion-reduce:tw-translate-y-1/3 tw-overflow-y-hidden tw-pointer-events-none',
      )}
    >
      <div className="tw-w-full tw-h-full tw-absolute -tw-bottom-[85%]">
        <Image
          src={smokeImgUrl}
          role="presentation"
          alt=""
          layout="fill"
          data-testid="smoke-image"
          className={classNames(
            'tw-object-cover tw-opacity-0',
            isAnimating && 'tw-animate-scale-up-1',
          )}
        />
      </div>
      <div className="tw-w-full tw-h-full tw-absolute -tw-bottom-3/4">
        <Image
          src={smokeImgUrl}
          role="presentation"
          alt=""
          layout="fill"
          className={classNames(
            'tw-object-cover tw-opacity-0',
            isAnimating && 'tw-animate-scale-up-2',
          )}
        />
      </div>
      <div className="tw-w-full tw-h-full tw-absolute -tw-bottom-3/4">
        <Image
          src={smokeImgUrl}
          role="presentation"
          alt=""
          layout="fill"
          className={classNames(
            'tw-object-cover tw-opacity-0',
            isAnimating && 'tw-animate-scale-up-3',
          )}
        />
      </div>
    </div>
  );
};

export default SmokeImages;
